<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Podere Poggio Scalette</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Cosa c'è nella Toscana che produce vini così pregiati? Sono le condizioni pittoresche, fila
                        su filari di sangiovese ben piantati? Sono le condizioni meteorologiche quasi ideali, calde nel
                        estate; freddo d'inverno? O è la conoscenza intrinseca dei suoi viticoltori, generazione dopo generazione
                        generazione del patrimonio tramandato di padre in figlio. Ebbene sì a tutti quelli, ma solo
                        25 anni, come si spiega Podere Poggio Scalette?
                    </div>

                    <div class="howto-title2">Cuore giovane, viti vecchie</div>
                    <div class="howto-text">
                        La risposta è semplice. Sì, Podere Poggio Scalette è ancora molto giovane tra i suoi pesi massimi
                        vicini supertoscani. E sì, l'enologo Jurij Fiore è ancora relativamente nuovo al buon vino
                        Attività commerciale. Ma quello che stiamo ignorando è l'importantissimo patrimonio sia del vigneto che del suo
                        creatore. Fiore non è altro che il celebre enologo Vittorio Fiore figlio e la vigna è incastonata
                        nientemeno che Il Carbonaione, la prima parte del Chianti ad essere ripiantata dopo la prima guerra mondiale.
                        Ciò significa che mentre Podere Poggio Scalette è giovane sulla carta, è sottolineato da 90 anni
                        vigne e anni di savoir-faire.
                    </div>

                    <div class="howto-title2">Performance irregolare nel circuito degli investitori di vini pregiati</div>
                    <div class="howto-text">
                        Dopo essersi ampliato nel 1996 e di nuovo nel 2007, Podere Poggio Scalette rimane relativamente piccolo. Solo 15 ettari della tenuta di 40 ettari sono dedicati alla vite (altri 10 producono il loro delizioso olio d'oliva). Quattro rossi e un bianco prodotti per una produzione di 45.000 bottiglie, il massimo
                        degno di nota è Il Carbonaione, dal nome della tenuta originaria. Un massimo costante
                        marcatore - L'offerta del 2015 ha ottenuto un punteggio di 95+ da Antonio Gallioni e 99 da James Suckling,
                        questa sarebbe la bottiglia migliore da aggiungere al tuo portafoglio, cantina o tavola. Prezzi molto ragionevoli,
                        la crescita tra il 2018 e il 2019 è stata di un costante 30%, anche se altre annate (2012) hanno sofferto
                        perdite significative.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Podere Poggio Scalette</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Was ist es eigentlich, das in der Toskana so gute Weine hervorbringt? Liegt es an den malerischen Verhältnissen, Reihe
                        auf einer Reihe ordentlich gepflanzter Sangiovese-Reben? Sind die nahezu idealen Wetterbedingungen, heiß in der
                        Sommer; kalt im Winter? Oder ist es das inhärente Wissen seiner Winzer von Generation zu Generation?
                        Generation des Erbes, das vom Vater an den Sohn weitergegeben wird. Nun ja, das alles, aber zumindest
                        25 Jahre alt, wie erklärt das Podere Poggio Scalette?
                    </div>

                    <div class="howto-title2">Junges Herz, alte Reben</div>
                    <div class="howto-text">
                        Die Antwort ist einfach. Ja, Podere Poggio Scalette ist im Schwergewicht noch sehr jung
                        supertoskanische Nachbarn. Und ja, der Winzer Jurij Fiore ist noch relativ neu in der Welt des edlen Weins
                        Geschäft. Aber was wir abtun, ist das überaus wichtige Erbe sowohl des Weinbergs als auch seiner Umgebung
                        Hersteller. Fiore ist kein geringerer als der Sohn des berühmten Önologen Vittorio Fiore und der Weinberg ist angelegt
                        in keinem anderen als Il Carbonaione, dem ersten Teil des Chianti, der nach dem Ersten Weltkrieg neu bepflanzt wurde.
                        Dies bedeutet, dass Podere Poggio Scalette zwar auf dem Papier jung ist, dies jedoch durch die Tatsache unterstrichen wird, dass er 90 Jahre alt ist
                        Reben und jahrelanges Savoir-faire.
                    </div>

                    <div class="howto-title2">Unregelmäßige Leistung im Kreis der Investoren für erlesene Weine</div>
                    <div class="howto-text">
                        Podere Poggio Scalette wurde 1996 und 2007 erweitert und ist nach wie vor relativ klein. Nur 15 Hektar des 40 Hektar großen Anwesens sind für den Weinanbau bestimmt (weitere 10 Hektar produzieren ihr köstliches Olivenöl). Vier Rotweine und ein Weißwein wurden für eine Produktion von 45.000 Flaschen produziert, also am meisten
                        Bemerkenswert ist das Il Carbonaione, benannt nach dem ursprünglichen Anwesen. Ein konstantes Hoch
                        Torschütze – das Angebot von 2015 erhielt eine Punktzahl von 95+ von Antonio Gallioni und 99 von James Suckling.
                        Dies wäre die beste Flasche für Ihr Portfolio, Ihren Keller oder Ihren Tisch. Sehr preisgünstig,
                        Das Wachstum zwischen 2018 und 2019 betrug stetig 30 %, obwohl andere Jahrgänge (2012) darunter litten
                        erhebliche Verluste.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Podere Poggio Scalette</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Qu'y a-t-il dans la Toscane qui produit des vins aussi fins ? Est-ce les conditions pittoresques, rangée
                        sur une rangée de vignes de Sangiovese soigneusement plantées? Est-ce que les conditions météorologiques presque idéales, chaud dans le
                        été; froid en hiver? Ou est-ce la connaissance inhérente de ses vignerons, génération après génération
                        génération d'héritage transmis de père en fils. Eh bien oui à tous ceux-là, mais juste
                        25 ans, comment cela explique-t-il Podere Poggio Scalette ?
                    </div>

                    <div class="howto-title2">Jeune cœur, vieilles vignes</div>
                    <div class="howto-text">
                        La réponse est simple. Oui, Podere Poggio Scalette est encore très jeune parmi ses poids lourds
                        voisins super toscans. Et oui, le vigneron Jurij Fiore est encore relativement nouveau dans le bon vin
                        entreprise. Mais ce que l'on écarte, c'est l'héritage si important du vignoble et de ses
                        fabricant. Fiore n'est autre que le célèbre œnologue Vittorio Fiore fils et le vignoble est planté
                        dans nul autre que Il Carbonaione, la première partie du Chianti à être replantée après la Première Guerre mondiale.
                        Cela signifie que si Podere Poggio Scalette est jeune sur le papier, il est souligné par 90 ans
                        vignes et des années de savoir-faire.
                    </div>

                    <div class="howto-title2">Performances erratiques sur le circuit des investisseurs en vins fins</div>
                    <div class="howto-text">
                        Après s'être agrandi en 1996 puis en 2007, Podere Poggio Scalette reste relativement petit. Seuls 15 hectares du domaine de 40 hectares sont consacrés à la vigne (10 autres produisent leur délicieuse huile d'olive). Quatre rouges et un blanc produits pour une production de 45 000 bouteilles, le plus
                        le plus remarquable est l'Il Carbonaione, nommé d'après le domaine d'origine. Un high constant
                        buteur - l'offre de 2015 a obtenu un score de 95+ d'Antonio Gallioni et 99 de James Suckling,
                        ce serait la meilleure bouteille à ajouter à votre portefeuille, cave ou table. Prix très raisonnable,
                        la croissance entre 2018 et 2019 a été stable à 30%, même si d'autres millésimes (2012) ont souffert
                        pertes importantes.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Podere Poggio Scalette</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        What is it about Tuscany that produces such fine wines? Is it the picturesque conditions, row
                        upon row of neatly planted Sangiovese vines? Is the almost ideal weather conditions, hot in the
                        summer; cold in the winter? Or is it the inherent knowledge of its winemakers, generation upon
                        generation of heritage passed down from father to son. Well yes to all of those, but at just
                        25-years old, how does that explain Podere Poggio Scalette?
                    </div>

                    <div class="howto-title2">Young heart, old vines</div>
                    <div class="howto-text">
                        The answer is simple. Yes, Podere Poggio Scalette is still very young amongst its heavyweight
                        super-Tuscan neighbours. And yes, winemaker Jurij Fiore is still relatively new to the fine wine
                        business. But what we are dismissing is the all-important heritage of both the vineyard and its
                        maker. Fiore is none other than celebrated oenologist Vittorio Fiore son and the vineyard is set
                        in none other than Il Carbonaione, the first part of Chianti to be replanted after World War I.
                        This means that while Podere Poggio Scalette is young on paper, it is underscored by 90-year old
                        vines and years of savoir-faire.
                    </div>

                    <div class="howto-title2">Erratic performance on the fine wine investors circuit</div>
                    <div class="howto-text">
                        Having expanded in 1996 and again in 2007, Podere Poggio Scalette remains relatively small. Just 15-hectares of the 40-hectares estate are given over to vines (another 10 produce their delicious olive oil). Four reds and one white produced for a 45,000 bottle production, the most
                        notable of which is the Il Carbonaione, named after the original estate. A consistent high
                        scorer - 2015’s offering earned a 95+ score from Antonio Gallioni and 99 from James Suckling,
                        this would be the best bottle to add to your portfolio, cellar or table. Very reasonably priced,
                        growth between 2018 and 2019 has been a steady 30%, although other vintages (2012) have suffered
                        significant losses.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PoderePoggioScalette",
    head: {
        title: 'Podere Poggio Scalette | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the excellence of Tuscany with Podere Poggio Scalette, a renowned wine producer renowned for its premium quality wines made from carefully selected grapes grown in the region\'s finest vineyards.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}
.wine-guide-left {
    width: 300px;
    display: inline-block;
}
.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}
.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}
.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}
.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
